import { render, staticRenderFns } from "./SubproyectosSidebar.vue?vue&type=template&id=16d7e4a0&scoped=true"
import script from "./SubproyectosSidebar.vue?vue&type=script&lang=js"
export * from "./SubproyectosSidebar.vue?vue&type=script&lang=js"
import style0 from "./SubproyectosSidebar.vue?vue&type=style&index=0&id=16d7e4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7e4a0",
  null
  
)

export default component.exports